export default __webpack_public_path__ + "static/media/2.29f2fce8.png";